const state = () => ({
    cache_videos: []
})

const mutations = {

    setCacheVideos(state, info) {
        state.cache_videos.push(info)
    }
}

const actions = {
    async setCacheVideos({ commit }, { info }) {
        commit('setCacheVideos', info)
    }
}


const getters = {
    cache_videos: state => state.cache_videos
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};